import { render, staticRenderFns } from "./datiTestata.html?vue&type=template&id=1bbf4d2c&"
import script from "./DatiTestata.vue?vue&type=script&lang=js&"
export * from "./DatiTestata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports